// @ts-check
import { useQuery } from '@tanstack/react-query';
import api from 'modules/queries/api';

/**
 * @param {import('club-sauce/public/monitoring/bandwidth/index.raw').LWApiPublicMonitoringBandwidthStatsParamsRawI} params
 * @param {object} [options]
 * @param {import('@tanstack/react-query').UseQueryOptions['enabled']} [options.enabled]
 */
const useMonitoringBandwidthStats = (params, options) =>
	useQuery({
		queryKey: ['/monitoring/bandwidth/stats', params],
		queryFn: () => api.monitoring.bandwidth.apiRaw.stats(params),
		enabled: options?.enabled,
	});

export default useMonitoringBandwidthStats;
